const WalletArrowUpIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6_191)">
        <path
          d="M20 16C20 16.828 19.328 17.5 18.5 17.5C17.672 17.5 17 16.828 17 16C17 15.172 17.672 14.5 18.5 14.5C19.328 14.5 20 15.172 20 16ZM23 8.00002C22.447 8.00002 22 8.44802 22 9.00002V21C22 21.551 21.552 22 21 22H5C3.346 22 2 20.654 2 19V9.00002V8.99502C2.854 9.63502 3.903 10 4.999 10H14.999C15.552 10 15.999 9.55202 15.999 9.00002C15.999 8.44802 15.552 8.00002 14.999 8.00002H5C4.144 8.00002 3.347 7.61902 2.783 6.99602C3.332 6.38902 4.118 6.00002 5 6.00002H12C12.553 6.00002 13 5.55202 13 5.00002C13 4.44802 12.553 4.00002 12 4.00002H5C2 4.00002 0 6.50002 0 9.00002V19C0 21.757 2.243 24 5 24H21C22.654 24 24 22.654 24 21V9.00002C24 8.44802 23.553 8.00002 23 8.00002ZM16.703 4.21102L18 2.93002V9.00002C18 9.55202 18.447 10 19 10C19.553 10 20 9.55202 20 9.00002V2.94802L21.303 4.21602C21.497 4.40502 21.748 4.50002 22 4.50002C22.261 4.50002 22.521 4.39902 22.717 4.19802C23.102 3.80202 23.094 3.16902 22.697 2.78402L20.47 0.616023C19.649 -0.202977 18.318 -0.201977 17.5 0.612023L15.296 2.78902C14.903 3.17702 14.9 3.81002 15.287 4.20302C15.677 4.59702 16.308 4.59902 16.702 4.21202L16.703 4.21102Z"
          fill="#01486D"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_191">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WalletArrowUpIcon;
